import React, { FC , useContext } from 'react';
import Modal from '@components/Modal';
import { DEFAULT_CURRENCY } from '@typings/common';
import dashboardContext from '@layouts/DashboardLayout/DashboardContext';
import { ApiDefinition } from '@noodleApi';
import * as ApiModels from '@typings/api-models';
import InvoiceSettings from '@/components/InvoiceSettings';
import LineItemEditor from '@components/LineItemEditor';
import ProgressIndicator from '@/components/ProgressIndicator';

type Props = {
    toggleModal: () => void;
    invoiceData: ApiDefinition['/invoices/{id}']['GET']['response'];
    handleSubmit: (data: {
        invoiceData: Pick<
          ApiModels.InvoiceTemplate,
          | 'title'
          | 'priceId'
          | 'isFollowupEnabled'
          | 'passProcessingFeesToCustomer'
          | 'isAchPaymentEnabled'
          | 'isCreditCardPaymentEnabled'
          | 'isDebitCardPaymentEnabled'
          | 'isDebitCardPaymentRequiredForCustomer'
          | 'isExemptFromApplicationFee'
          | 'secondaryStripeAccountId'
          | 'isPartialPaymentEnabled'
          | 'areClientModificationDisabled'
          | 'modificationNotAllowedMessage'
          | 'confidoBankAccountId'
          | 'minimumAmount'
        >;
        lineItems: NonNullable<Parameters<typeof LineItemEditor>[0]['initialValue']>;
      }) => Promise<void>;
};
const EditInvoiceModal: FC<Props> = ({toggleModal, invoiceData, handleSubmit}) => {
  const { creator } = useContext(dashboardContext);

  return(
    <Modal title={'Edit Invoice'} onClose={toggleModal} >
      <>
        {!invoiceData && <ProgressIndicator isCentered />}
        {invoiceData && <InvoiceSettings
          currency={creator?.defaultCurrency || DEFAULT_CURRENCY}
          initialValue={invoiceData}
          onSave={handleSubmit}
          cta='Save'
          requireLineItems
        />}
      </>
    </Modal>
  );
};

export default EditInvoiceModal;